import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  accountId: {
    fontSize: 14,
    marginLeft: 6
  },
  header: {
    fontSize: 18,
    marginTop: 16
  },
  info: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    lineHeight: 1.2,
    marginTop: 8
  },
  btn: {
    width: '100%',
    maxWidth: 300,
    marginTop: 20
  }
})

export default useStyles
